<template>
    <div>
        <b-tabs class="pre-class-school-list__filter__tabs b-child-tabs">
            <b-tab @click="changeTab(tabNew)" title="Bài giảng mới" :active="tabActive == tabNew">
                <div v-if="tabActive == tabNew">
                    <div class="row" v-if="listDataElectronicLecturesClassSchool.length > 0">
                        <div class="col-md-4" v-for="(item, index) of listDataElectronicLecturesClassSchool"
                            :key="index">
                            <ItemElectronicLectures :type="paramQueryData.type" :status="paramQueryData.status"
                                :item="item" :className="className" />
                        </div>
                    </div>
                    <div class="text-center empty-data" v-else>Không có dữ liệu bài giảng mới</div>
                </div>
            </b-tab>
            <b-tab @click="changeTab(tabProcess)" title="Bài giảng đang hoàn thành" :active="tabActive == tabProcess">
                <div v-if="tabActive == tabProcess">
                    <div class="row" v-if="listDataElectronicLecturesClassSchool.length > 0">
                        <div class="col-md-4" v-for="(item, index) of listDataElectronicLecturesClassSchool"
                            :key="index">
                            <ItemElectronicLectures :type="paramQueryData.type" :status="paramQueryData.status"
                                :item="item" :className="className" />
                        </div>
                    </div>
                    <div class="text-center empty-data" v-else>Không có dữ liệu bài giảng đang hoàn thành</div>
                </div>
            </b-tab>
            <b-tab @click="changeTab(tabComplete)" title="Bài giảng đã hoàn thành" :active="tabActive == tabComplete">
                <div v-if="tabActive == tabComplete">
                    <div class="row" v-if="listDataElectronicLecturesClassSchool.length > 0">
                        <div class="col-md-4" v-for="(item, index) of listDataElectronicLecturesClassSchool"
                            :key="index">
                            <ItemElectronicLectures :type="paramQueryData.type" :status="paramQueryData.status"
                                :item="item" :className="className" />
                        </div>
                    </div>
                    <div class="text-center empty-data" v-else>Không có dữ liệu bài giảng đã hoàn thành</div>
                </div>
            </b-tab>
        </b-tabs>
        <div class="row pagination container m-0">
            <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
                :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
        </div>
    </div>

</template>

<script>
import ItemElectronicLectures from './../../_components/ItemElectronicLectures.vue';
import { listLessonClassSchoolUserService } from './../../_api/lessonClassSchoolUserServices';
export default {
    name: 'ElectronicLecturesClassSchool',
    components: {
        ItemElectronicLectures
    },
    watch: {
        'paramQueryData.pageIndex': 'getListElectronicLecturesClassSchool',
        'paramQueryData.keyword': 'getListElectronicLecturesClassSchool'
    },
    props: {
        className: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tabActive: 1,
            tabNew: 1,
            tabProcess: 2,
            tabComplete: 3,

            paramQueryData: {
                classSchoolId: 0,
                type: 2,
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
                status: 1
            },
            listDataElectronicLecturesClassSchool: [],
            totalRecords: 0,
        }
    },
    mounted() {
        this.paramQueryData.classSchoolId = this.$route.query.id
        this.getListElectronicLecturesClassSchool()
    },
    methods: {
        changeTab(tab) {
            this.tabActive = tab
            this.paramQueryData.status = tab
            this.getListElectronicLecturesClassSchool()
        },
        getListElectronicLecturesClassSchool() {
            this.paramQueryData.status = this.tabActive
            let self = this
            listLessonClassSchoolUserService(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataElectronicLecturesClassSchool = res.data.list
                    self.totalRecords = res.data.paging.totalRecords
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.pagination {
    margin-bottom: 20px;
}
</style>